import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Alert,
} from "@mui/material";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import axios from "axios";

function Holidays() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [id, setId] = useState();
  const [count, setCount] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [holidays, setHolidays] = useState([]);

  const setValue0 = (name, val) => {
    if (!name) return null;
    setValue((v) => ({ ...v, [name]: val }));
  };

  const onSuccess = () => setCount((v) => v + 1);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axios.get("/api/holidays");
        const holidayDates = response.data.data.map((holiday) => holiday.date); 
        setHolidays(holidayDates);
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    fetchHolidays();
  }, []);

  const holidayColumns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? value : "N/A";
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">
            <IconButton
              onClick={() => {
                setId(v);
                const obj = list.find((x) => x.id === v);
                // console.log("Edit clicked - Full object:", obj);
                // console.log("Date value:", obj.date, "Type:", typeof obj.date);
                setValue({
                  name: obj.name,
                  date: obj.date,
                  description: obj.description,
                });
                setOpen(2);
              }}
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Edit"
                className="mr-2 text-sm"
              />
            </IconButton>
            <IconButton
              onClick={() => {
                // console.log("Delete button clicked for ID:", v);
                setId(v);
                setDeleteOpen(true);
              }}
            >
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Delete"
                className="mr-2 text-sm"
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];

  return (
    <Box sx={{ padding: "16px" }}>
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/holidays/${id}`} 
      />
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/holidays" : `/api/holidays/${id}`}
        method={open === 1 ? "POST" : "POST"}
        title={
          <>
            {open === 1 ? "Add New Holiday" : "Edit Holiday"}
            <Alert severity="info" sx={{ mb: 2 }}>
              Please enter the date with the month first, followed by the day
            </Alert>
          </>
        }
        fields={[
          {
            name: "name",
            label: "Name",
            value: value["name"],
            required: true,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "date",
            label: "Date",
            value: value["date"] || "",
            required: true,
            placeholder: "Month-Date ",
            setValue: (val) => {
              if (val === null || val === undefined || val === "") {
                setValue0("date", ""); 
              } else if (val.match(/^\d{0,2}-?\d{0,2}$/)) {
                setValue0("date", val);
              }
            },
          },
        ]}
      />
      <DatatableComponent
        onAddNew={() => setOpen(1)}
        search={false}
        viewColumns={false}
        searchfield={true}
        
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={holidayColumns}
        url={`/api/holidays?count=${count}`} 
        title="Holidays"
      />
    </Box>
  );
}

export default Holidays;
